import React from "react";

import ReactView from "shared/react_view";

import SourceVirtualLine from '../models/source_virtual_line';
import VirtualLineMover from '../models/virtual_line_mover';
import MoveModal from '../components/MoveModal';
import BulkMoveModal from "../components/BulkMoveModal";

export default class MoveVirtualLineModal {
  constructor(config, virtualLineAttributes) {
    this.sourceVirtualLines = virtualLineAttributes.map((sourceAttributes) => new SourceVirtualLine(sourceAttributes));
    this.virtualLineMover = new VirtualLineMover(config, this.sourceVirtualLines);
    this.successCallback = config.successCallback;
    this.moveType = config.moveType;
  }

  render() {
    if (this.moveType === "single") {
      return new ReactView(<MoveModal
        virtualLineMover={this.virtualLineMover}
        successCallback={this.successCallback}
      />).render();
    } else {
      return new ReactView(<BulkMoveModal
        virtualLineMover={this.virtualLineMover}
        successCallback={this.successCallback}
      />).render();
    }
  }
}
